import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import CheckMark from "../../../../assets/icons/auth-form/check-mark.png";
import CrossMark from "../../../../assets/icons/auth-form/cross-mark.png";
import DoesntMatter from "../../../../assets/icons/auth-form/doesnt-matter.svg";
import { getOptionsFromEnums } from "../../../../shared/utility";
import { preferenceEnums } from "../../../../system/global-enums";
import { EMPTY_STRING } from "../../../../constants";

const options = getOptionsFromEnums(preferenceEnums.DECISION_CHOICES);
const VisaPreference = () => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className="question-heading">
        Does the country need to be visa free?
      </div>
        {errors.visaFreeCountry && (
          <div className="error">{errors.visaFreeCountry.message}</div>
        )}
      <div className="form-fields">
        {options.map((option, index) => (
          <SurveyFormField
            key={index}
            name="visaFreeCountry"
            variant="radio"
            label={option.label}
            value={option.value}
            endAdornment={
              <div className="position-absolute marks-adornment">
                <img
                  src={
                    Number(option.value) === 1
                      ? CheckMark
                      : Number(option.value) === 2
                      ? CrossMark
                      : DoesntMatter
                  }
                  alt={EMPTY_STRING}
                />
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default VisaPreference;
